{
  "en": {
    "todo_group": {
      "actions": {
        "create": "Task",
        "update": "Edit task"
      },
      "attributes": {
        "category": "Category",
        "created_at": "Created",
        "description": "Description",
        "title": "Title",
        "todos_count": "Tasks",
        "units": "Units"
      },
      "categories": {
        "confirmation": "Confirmation",
        "upload": "Upload"
      },
      "labels": {
        "no_groups": "No tasks for this project yet.",
        "required": "This field is required"
      },
      "toasts": {
        "create": "Task created",
        "delete": "Task deleted",
        "update": "Task updated"
      }
    }
  }
}
